"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.transformKeysToCamelCase = void 0;
const transformKeysToCamelCase = data => {
  if (typeof data === 'object' && data !== null) {
    if (Array.isArray(data)) {
      return data.map(transformKeysToCamelCase);
    }
    return Object.keys(data).reduce((acc, key) => {
      const camelCaseKey = key.charAt(0).toLowerCase() + key.slice(1);
      return {
        ...acc,
        [camelCaseKey]: transformKeysToCamelCase(data[key])
      };
    }, {});
  }
  return data;
};
exports.transformKeysToCamelCase = transformKeysToCamelCase;
